import "./Styles/Cookies.css";
import { BrowserRouter, Routes, Route, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Fragment } from "react";
import ReactGA from "react-ga";
import { createBrowserHistory } from "history";
import axios from "axios";
import CanadaMain from "./Canada/Components/Home/Main";
import CanadaGapAnalysis from "./Canada/RedirectingPages/NavbarPages/BusinessAudit";
import CanadaBespokeSystem from "./Canada/RedirectingPages/NavbarPages/BespokeSystem";
import CanadaWebDevelopment from "./Canada/RedirectingPages/NavbarPages/BusinessAutomation";
import CanadaDigitalMarket from "./Canada/RedirectingPages/NavbarPages/SoftwareDevelopment";
import CanadaMobileApp from "./Canada/RedirectingPages/NavbarPages/MobileApp";
import CanadaDedicatedResource from "./Canada/RedirectingPages/NavbarPages/DedicatedResource";
import CanadaAboutUs from "./Canada/RedirectingPages/FooterPages/AboutCompany";
import CanadaContactUs from "./Canada/RedirectingPages/FooterPages/ContactUs";
import CanadaCareer from "./Canada/RedirectingPages/FooterPages/Career";
import CanadaMainTestimonial from "./Canada/RedirectingPages/FooterPages/MainTestimonial";
import CanadaPricingTable from "./Canada/RedirectingPages/FooterPages/PricingTable";
import CanadaSeoManagement from "./Canada/RedirectingPages/Packages/SeoManagement";
import CanadaBlog from "./Canada/RedirectingPages/FooterPages/Blog";
import CanadaBlogDetails from "./Canada/RedirectingPages/FooterPages/AllBlogs/BlogDetails";
import CanadaPolicy from "./Canada/RedirectingPages/FooterPages/Policy";
import CanadaDigitalMarketing from "./Canada/RedirectingPages/FooterPages/DigitalMarketing";
import CanadaHostingServices from "./Canada/RedirectingPages/FooterPages/HostingServices";
import CanadaMicroService from "./Canada/RedirectingPages/FooterPages/MicroService";
import CanadaAllGallery from "./Canada/RedirectingPages/AllGallery";
import CanadaCurrentOPening from "./Canada/RedirectingPages/FooterPages/CurrentOPening";
import CanadaDetails2 from "./Canada/RedirectingPages/FooterPages/CareerDetails/Details2";
import CanadaEmployeeVideo from "./Canada/RedirectingPages/EmployeeVideo";
import CanadaWebsiteDevelopment from "./Canada/RedirectingPages/NavbarPages/WebsiteDevelopment";
import ScrollTop from "./Canada/RedirectingPages/NavbarPages/ScrollTop";
import CallBack from "./Canada/RedirectingPages/NavbarPages/CallBack";
import CaseStudy1 from "../src/Canada/Components/Case Studies/CaseStudy1";


ReactGA.initialize("UA-76559070-1");
const browserHistory = createBrowserHistory();
browserHistory.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
});

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const [ip, setIP] = useState("");
  const [long, setLong] = useState("");
  const [latt, setLatt] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState('')

  const getData = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      setLatt(res.data.latitude);
      setLong(res.data.longitude);
      setIP(res.data.IPv4);
      setCity(res.data.city);
      setCountry(res.data.country_name);
    } catch (error) {
      console.error("Error fetching geolocation data:", error);
      // Set default or empty values on error
      setLatt("");
      setLong("");
      setIP("");
      setCity("");
      setCountry("");
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const [shown, setShown] = useState(true);

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 2 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + true + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    localStorage.setItem("latitude", latt);
    localStorage.setItem("longitude", long);
    localStorage.setItem("IpAddress", ip);
    localStorage.setItem("City", city);
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
  
  }

  function checkCookieBanner() {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      var x = document.getElementById("cookiesBox");
      x.style.display = "block";
    }
  }

  const onDecline = () => {
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";
  };

  const onSaveSettings = () => {
    let user = getCookie("zithasTech");
    if (user != "") {
      var x = document.getElementById("cookiesBox");
      x.style.display = "none";
    } else {
      setCookie("zithasTech", user, 30);
    }
    var x = document.getElementById("cookiesBox");
    x.style.display = "none";

    var checkBox = document.getElementById("analytics_cookies");
    if (checkBox.checked == true) {
      localStorage.setItem("latitude", latt);
      localStorage.setItem("longitude", long);
      localStorage.setItem("IpAddress", ip);
      localStorage.setItem("City", city);
    } else if (checkBox.checked == false) {
      return false;
    }

    var checkBox = document.getElementById("functional_cookies");
    if (checkBox.checked == true) {
      console.log("Functional Coocikes is Acctivated");
    } else {
      console.log("Functional Coocikes is Deacctivated");
    }
  };
  
  return (
    <div className="App">
      <BrowserRouter>
        <Fragment>
          {/* <ScrollToTop /> */}
          <ScrollTop />
          <CallBack />
          <Routes>
            {/* USA Routes */}
            <Route exact path="/" element={<CanadaMain />}></Route>
            <Route exact path="/business-automation" element={<CanadaWebDevelopment />}></Route>
            <Route exact path="/business-software-audit" element={<CanadaGapAnalysis />}></Route>
            <Route exact path="/bespoke-systems" element={<CanadaBespokeSystem />} ></Route>
            <Route exact path="/custom-software-development" element={<CanadaDigitalMarket />} ></Route>
            <Route exact path="/website-development" element={<CanadaWebsiteDevelopment />} ></Route>
            <Route exact path="/mobile-apps-development" element={<CanadaMobileApp />} ></Route>
            <Route exact path="/hire-a-resource" element={<CanadaDedicatedResource />} ></Route>
            <Route path="/case-study/:permalink" element={<CaseStudy1/>} />
            <Route exact path="/about-us" element={<CanadaAboutUs />} ></Route>
            <Route exact path="/contact-us" element={<CanadaContactUs />} ></Route>
            <Route exact path="reer" element={<CanadaCareer />} ></Route>
            <Route exact path="/testimonials" element={<CanadaMainTestimonial />}></Route>  
            <Route exact path="/Maintenance-Packages" element={<CanadaPricingTable />} ></Route>
            <Route exact path="/seo-management-packages" element={<CanadaSeoManagement />} ></Route>
            <Route exact path="/blog" element={<CanadaBlog />} ></Route>
            <Route exact path="/blog/:permalink" element={<CanadaBlogDetails />} ></Route>
            <Route exact path="/Privacy-policy" element={<CanadaPolicy />} ></Route>
            <Route exact path="/digital-marketing" element={<CanadaDigitalMarketing />} ></Route>
            <Route exact path="/hosting-service" element={<CanadaHostingServices />} ></Route>
            <Route exact path="/micro-service" element={<CanadaMicroService />} ></Route>
            <Route exact path="/gallery" element={<CanadaAllGallery />} ></Route>
            <Route exact path="/current-opening" element={<CanadaCurrentOPening />} ></Route>
            <Route exact path="/current-opening/:permalink" element={<CanadaDetails2 />} ></Route>
            <Route exact path="/employee-testimonial" element={<CanadaEmployeeVideo />} ></Route>
          </Routes>     
        </Fragment>
      </BrowserRouter>
    </div>
  );
}
export default App;
